import { onLocationLayerLeave, onPropertyLayerLeave } from './mouse';

const onMapMouseOut = ( ctx, event ) => {
    onPropertyLayerLeave( ctx, event );
    onLocationLayerLeave( ctx, event );
};

export default onMapMouseOut;
